export default "__VITE_ASSET__046e52fa__"